import React, { useState, MouseEvent, useEffect } from 'react';
import { Box, Button, colors, Menu, MenuItem, Typography, useMediaQuery, useTheme } from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

import configSiteUrls from '../../configs/configSiteUrls';
import { useGetPublicMenusQuery } from '../../features/menus/menuPai/menuPaiApiSlice';
import { MenuSiteFilhoListDTO, MenuSiteNetoListDTO, MenuSitePaiListDTO } from '../../../../typesSite/menuPrincipalSite/MenuSiteListDTO';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import { setMenu, setMenuLayout } from '../../features/menus/menuPrincipalSite/menuPrincipalSiteSlice';
import { NavLinkButton } from './NavLinkButton';
import { NavLinkMenuItem } from './NavLinkMenuItem';
import { ArrowDownward } from '@mui/icons-material';
import { ArrowDropDownIcon } from '@mui/x-date-pickers/icons';
import { UsuarioAdminSite } from '../../../../utils/usuarioEstaLogado';
type DesktopMenuDrawerProps = {
  layout: 'site' | 'escolaLegislativo';
};

export const DesktopMenuDrawer: React.FC<DesktopMenuDrawerProps> = ({ layout }) => {
  const dispatch = useAppDispatch();
  const menuSite = useAppSelector(state => state.menuPrincipalSite).menu;
  const menuLayoutSlice = useAppSelector(state => state.menuPrincipalSite).layout;
  const usuarioAdminSite = UsuarioAdminSite();


   const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const headerMenu = theme.custom?.headerSiteMenu || {};
    const textColorMobile = headerMenu.textColorMobile || '#ffffff';
   
  



  const { data, error, isLoading, isFetching, refetch } = useGetPublicMenusQuery(
    { escolaLegislativo: layout === 'escolaLegislativo' },
    {
      skip: menuSite.length > 0 && menuLayoutSlice === layout,
      refetchOnMountOrArgChange: false,
      refetchOnFocus: false,
      refetchOnReconnect: false
    }
  );

  useEffect(() => {
    if (data) {
      dispatch(setMenu(data));
      dispatch(setMenuLayout(layout));
    }
  }, [data, dispatch, layout]);

  const [anchorPai, setAnchorPai] = useState<{
    [index: number]: HTMLElement | null;
  }>({});
  const [anchorFilho, setAnchorFilho] = useState<{
    [key: string]: HTMLElement | null;
  }>({});

  const handleOpenPai = (index: number, event: MouseEvent<HTMLElement>) => {
    setAnchorPai(prev => ({ ...prev, [index]: event.currentTarget }));
  };

  const handleClosePai = (index: number) => {
    setAnchorPai(prev => ({ ...prev, [index]: null }));
    setAnchorFilho({});
  };

  const handleOpenFilho = (key: string, event: MouseEvent<HTMLElement>) => {
    setAnchorFilho(prev => ({ ...prev, [key]: event.currentTarget }));
  };

  const handleCloseFilho = (key: string) => {
    setAnchorFilho(prev => ({ ...prev, [key]: null }));
  };

  /*
  if (isLoading || isFetching) {
    return <div>Loading...</div>;
  }
*/
  return (
    <Box sx={{ display: 'flex', gap: 2 }}>
      {menuSite.map((menuPai: MenuSitePaiListDTO, indexPai) => {
        const podeExibir = menuPai.label.toUpperCase() === 'ADM' ? usuarioAdminSite : true;
        if (!podeExibir) return null;


        
        return (
          <Box key={indexPai}>
            {menuPai.filhos && menuPai.filhos.length > 0 ? (
              <>
                <Button
                  onClick={e => handleOpenPai(indexPai, e)}
                  sx={{
                    color: layout === 'escolaLegislativo' ? 'primary.main' : 'inherit',
                    fontSize: '12px',
                    fontWeight: 700,
                    borderBottom: '2px solid transparent',
                    borderRadius: 0,
                    '&:hover': {
                      borderBottom: `2px solid ${textColorMobile}`,
                      backgroundColor: 'transparent'
                    }
                  }}
                >
                  {menuPai.label}
                  <ArrowDropDownIcon fontSize="small" />
                </Button>

                <Menu
                  anchorEl={anchorPai[indexPai]}
                  open={Boolean(anchorPai[indexPai])}
                  onClose={() => handleClosePai(indexPai)}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                >
                  {menuPai.filhos.map((menuFilho: MenuSiteFilhoListDTO, indexFilho) => {
                    const keyFilho = `${indexPai}-${indexFilho}`;
                    const hasNeto = menuFilho.netos && menuFilho.netos.length > 0;

                    return (
                      <div key={keyFilho}>
                        <NavLinkMenuItem
                          link={menuFilho.link}
                          noticiaId={menuFilho.noticiaId}
                          onMouseEnter={hasNeto ? (e: React.MouseEvent<HTMLElement>) => handleOpenFilho(keyFilho, e) : undefined}
                          onClick={() => {
                            if (!hasNeto) handleClosePai(indexPai);
                          }}
                          sx={{ justifyContent: 'space-between', color: layout === 'escolaLegislativo' ? 'primary.main' : 'inherit' }}
                        >
                          {menuFilho.label}
                          {hasNeto && <ArrowRightIcon fontSize="small" />}
                        </NavLinkMenuItem>

                        {/* Submenu neto */}
                        {hasNeto && (
                          <Menu
                            anchorEl={anchorFilho[keyFilho]}
                            open={Boolean(anchorFilho[keyFilho])}
                            onClose={() => handleCloseFilho(keyFilho)}
                            anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'right'
                            }}
                            transformOrigin={{
                              vertical: 'top',
                              horizontal: 'left'
                            }}
                          >
                            {menuFilho.netos?.map((menuNeto: MenuSiteNetoListDTO, indexNeto) => (
                              <NavLinkMenuItem
                                key={`${keyFilho}-${indexNeto}`}
                                link={menuNeto.link}
                                noticiaId={menuNeto.noticiaId}
                                onClick={() => {
                                  handleCloseFilho(keyFilho);
                                  handleClosePai(indexPai);
                                }}
                                sx={{ pl: 4, color: layout === 'escolaLegislativo' ? 'primary.main' : 'inherit' }}
                              >
                                {menuNeto.label}
                              </NavLinkMenuItem>
                            ))}
                          </Menu>
                        )}
                      </div>
                    );
                  })}
                </Menu>
              </>
            ) : (
              <NavLinkButton layout={layout} link={menuPai.link} noticiaId={menuPai.noticiaId} label={menuPai.label} />
            )}
          </Box>
        );
      })}
    </Box>
  );
};
